var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap btm_b",class:{ dark: this.color }},[_c('div',{staticClass:"modal_wrap"},[_c('router-view',{key:_vm.$route.fullPath}),_c('Footer',{on:{"calListOpen":_vm.calListOpen}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }